/* Wanderth — Reveals al hacer scroll.
   Motor: IntersectionObserver (pasivo, no escucha el evento scroll → no frena el hilo).
   Solo anima transform/opacity (compositor GPU, sin reflow).

   Patrón a prueba de fallos: la clase que OCULTA (.wnd-reveal) se añade DESDE JS.
   Si el JS no corre (o el navegador es viejo), el contenido se ve normal — nunca
   queda invisible. Respeta prefers-reduced-motion y el ajuste data-disable-animations
   del tema. Las secciones que ya están a la vista al cargar NO se ocultan (evita el
   parpadeo arriba del "fold"): la animación es solo para lo que aparece al bajar. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animationsOff = document.body.getAttribute('data-disable-animations') === 'true';

    if (reduceMotion || animationsOff || !('IntersectionObserver' in window)) return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = [].slice.call(main.querySelectorAll(':scope > .shopify-section'));
    if (!sections.length) return;

    var viewportH = window.innerHeight || document.documentElement.clientHeight;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('wnd-reveal--in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach(function (el) {
      // Solo preparar (ocultar) lo que arranca por debajo del primer pantallazo.
      if (el.getBoundingClientRect().top > viewportH * 0.85) {
        el.classList.add('wnd-reveal');
        observer.observe(el);
      }
    });
  });
})();
